export default __webpack_public_path__ + "static/media/call-incoming.fa6eaa08.svg";